import React from 'react';
import BounceLoader from 'react-spinners/BounceLoader';
import styled from 'styled-components';
import useFileUpload from './useFileUpload';

const Wrappies = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border-width: 2px;
  border-radius: 2px;
  border-color: #eeeeee;
  border-style: dashed;
  background-color: #fafafa;
  color: #bdbdbd;
  outline: none;
  transition: border 0.24s ease-in-out;
`;

interface ImageUploaderProps {
  setImage: (image: string) => void;
}

const ImageUploader = ({ setImage }: ImageUploaderProps) => {
  const { loading, getRootProps, getInputProps, isDragActive } = useFileUpload({
    url: '/image/upload',
    directory: 'assets',
    onSuccess: setImage,
  });

  return (
    <Wrappies {...getRootProps()}>
      <input {...getInputProps()} />
      {loading ? (
        <BounceLoader size={40} color="#7D4CDB" loading={true} />
      ) : isDragActive ? (
        <p>Dropp bildet her ...</p>
      ) : (
        <p>Dropp bildet her, eller klikk for å velge fil</p>
      )}
    </Wrappies>
  );
};

export default ImageUploader;
